import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'HOME', path: '/' },
    { label: 'Storefront Glass & Doors', path: '/storefront-glass-doors' },
    { label: 'SERVICES', path: '/services' },
    { label: 'PROJECTS', path: '/projects' },
    { label: 'CONTACT', path: '/#contact' },
    { label: 'Portfolio', path: '/portfolio' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 py-4 md:px-6 md:py-6">
        <nav className="flex items-center justify-between md:justify-center">
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden flex flex-col gap-1.5 p-2 cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <span className={`w-6 h-0.5 transition-all ${isScrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`w-6 h-0.5 transition-all ${isScrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`w-6 h-0.5 transition-all ${isScrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
          </button>

          {/* Desktop Navigation */}
          <ul className="hidden md:flex items-center space-x-10">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                    isScrolled
                      ? 'text-gray-900 hover:text-teal-600'
                      : 'text-white hover:text-teal-300 drop-shadow-lg'
                  } ${location.pathname === item.path ? 'font-bold' : ''}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Logo/Brand for mobile */}
          <div className={`md:hidden text-lg font-bold ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
            Global Tech Glass
          </div>
        </nav>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className={`md:hidden mt-4 py-4 rounded-lg ${isScrolled ? 'bg-white' : 'bg-black/80'}`}>
            <ul className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`block px-4 py-2 text-base font-semibold transition-colors cursor-pointer ${
                      isScrolled
                        ? 'text-gray-900 hover:text-teal-600 hover:bg-gray-50'
                        : 'text-white hover:text-teal-300'
                    } ${location.pathname === item.path ? 'font-bold' : ''}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}
